import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { FeaturedShops } from './components/FeaturedShops';
import { HowItWorks } from './components/HowItWorks';
import { TestimonialsSection } from './components/TestimonialsSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-gold/30 selection:text-forest-dark" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ServicesSection data-id="element-4" />
        <FeaturedShops data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}